import {Component, Input, OnInit} from '@angular/core';

@Component({
  standalone: true,
  selector: 'ct-lib-progress-bar',
  templateUrl: './progress-bar.component.html',
  imports: [],
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {
  @Input() value = 0;
  @Input() color = 'var(--secondary)';

  

  ngOnInit(): void {
    if (this.value < 0) this.value = 0;
    if (this.value > 100) this.value = 100;
  }
}
